<template>
  <div
    id="app"
    class="container-fluid vh-100 px-0"
    :class="{ 'unicorn': isAnUnicorn }"
  >
    <transition
      tag="div"
      name="fade"
    >
      <v-menu-mobile v-if="showMenuMobile" />
    </transition>
    <transition
      tag="div"
      name="fade"
    >
      <div
        v-if="focusScreen"
        class="position-absolute vw-100 vh-100"
        :style="`background: rgba(152, 162, 174, 0.5); z-index: 10;`"
      />
    </transition>
    <div
      v-if="appReady"
      id="containerApp"
      class="d-flex flex-column h-100 bg-gray-200"
      style="overflow-y: scroll; overflow-x: hidden;"
      :style="`overflow-y: ${focusScreen ? 'hidden' : 'scroll'};`"
    >
      <transition
        tag="div"
        name="fade"
      >
        <router-view
          v-if="showModal"
          id="modalApp"
          name="modal"
        />
      </transition>
      <v-toast />
      <router-view
        :key="$route.fullPath"
        name="default"
      />
      <transition
        tag="div"
        name="fade"
      >
        <router-view
          v-if="showFooter"
          name="footer"
        />
      </transition>
    </div>
    <v-loading-box
      v-else
      color="blue-500"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { routing, ui } from '@/mixins';

import helpers from '@/utils/_Strings';

import Toast from '@/components/common/helpers/Toast.vue';
import DashboardMenuMobile from '@/components/common/layout/DashboardMenuMobile.vue';
import Loadingbox from '@/components/common/helpers/LoadingAnimation.vue';

export default {
  name: 'App',
  components: {
    'v-toast': Toast,
    'v-menu-mobile': DashboardMenuMobile,
    'v-loading-box': Loadingbox,
  },
  mixins: [routing, ui],
  data() {
    return {
      params: {},
      appReady: false,
    };
  },
  computed: {
    ...mapGetters({
      isLogged: 'client/isLogged',
      showModal: 'ui/showModal',
      showFooter: 'ui/showFooter',
      focusScreen: 'ui/focusScreen',
      isAnUnicorn: 'isAnUnicorn',
      showMenuMobile: 'ui/menuMobile',
    }),
    key() {
      if (this.$route.matched[0]) {
        return this.$route.matched[0].path;
      }
      return 'initial';
    },
  },
  watch: {
    isLogged: {
      handler(value) {
        const message = value ? 'Vous êtes connecté !' : 'Vous êtes déconnecté !';
        this.ui_showToast({ show: true, message });
        if (!value && this.$route.path !== '/login') {
          this.$router.push('/login');
        }
      },
    },
  },
  created() {
    this.$store.dispatch('analytics/setDataLayer', this.$gtm.dataLayer() || []);
    this.$store.dispatch('analytics/setHotjar', window.hj || (() => {}));
  },
  mounted() {
    if (this.$route.name !== 'signatureConfirmation') {
      this.$store.dispatch('intercom/boot');
    }
  },
  beforeMount() {
    this.params = helpers.parseQueryString(window.location.search);
    if (window.location.pathname) {
      switch (window.location.pathname) {
        case '/signature':
          this.$store.dispatch('signature', this.params);
          this.appReady = true;
          return;
        case '/request-password':
          this.$router.replace(`/password?id=${this.params.id}&token=${this.params.token}`);
          break;
        case '/unicorn-login':
          this.$store.dispatch('specialEvent', this.params.token);
          this.$router.replace('/client/home');
          break;
        default:
          break;
      }
    }
    this.initialise();
  },
  methods: {
    checkSignatureRedirection(haveSignature) {
      console.log('checking signature redirection');
      const isFromSignature = this.$route.query.from === 'signature';
      const signaturesJustCompleted = this.$store.getters['company/signaturesJustCompleted'];

      if (haveSignature && !isFromSignature && !signaturesJustCompleted) {
        this.$router.push('/client/signature');
      }

      if (signaturesJustCompleted) {
        this.$store.dispatch('company/setValue', { signaturesJustCompleted: false });
      }
    },

    async initialise() {
      try {
        let { token } = this.$route.query;
        const { id, unicorn } = this.$route.query;
        if (!token) {
          this.params = helpers.parseQueryString(window.location.search);
          // eslint-disable-next-line prefer-destructuring
          token = this.params.token;
        }
        const {
          isLogged,
          haveSignature,
        } = await this.$store.dispatch('authenticate', { token, id, unicorn });
        await this.$store.dispatch('rater/initialize');
        if (isLogged) {
          await this.$store.dispatch('payments/getPaymentMethods');
          await this.$store.dispatch('claim/getClaims');
        }

        this.checkSignatureRedirection(haveSignature);

        this.appReady = true;
        if (this.isAnUnicorn) {
          this.$router.replace('/client/home');
        }
      } catch(err) {
        this.appReady = true;
        if (this.$route.path !== '/login'
        && this.$route.path !== '/request-password'
        && this.$route.path !== '/password'
      ) {
          this.$router.replace('/login');
        }
      }
    },
  },
};
</script>

<style lang="scss">
@use "./assets/styles/transition.scss";
</style>
<style scoped>
.unicorn {
  border: 15px groove var(--bs-blue-400);
}
</style>
<style lang="css">
.overflow-x-hidden {
  overflow-x: hidden;
}
.lead {
  color: var(--bs-blue-700);
}
body {
  color: var(--bs-gray-600);
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.cursor-pointer {
  cursor: pointer;
}
.mnh-100 {
  min-height: 100%!important;
}
@media screen and (min-width: var(--breakpoint-md)) {
  .mnh-md-100 {
    min-height: 100%!important;
  }
}
.form-control::-webkit-input-placeholder,
.form-control:-moz-placeholder
.form-control::-moz-placeholder,
.form-control::placeholder,
.form-control:-ms-input-placeholder {
  color: #98A2AE;
}
.rounded-4 {
  border-radius: 20px;
}
.transition-shadow {
  transition: box-shadow .5s;
}
</style>
